import { render, staticRenderFns } from "./color-block.vue?vue&type=template&id=3eff9e72&scoped=true&"
import script from "./color-block.vue?vue&type=script&lang=js&"
export * from "./color-block.vue?vue&type=script&lang=js&"
import style0 from "./color-block.vue?vue&type=style&index=0&id=3eff9e72&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3eff9e72",
  null
  
)

export default component.exports